"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDrawerOverlay = exports.ChildrenContainer = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
const ChildrenContainer = exports.ChildrenContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "ChildrenContainer",
  class: "c173ci9p",
  vars: {
    "c173ci9p-0": [props => props.height]
  }
});
const StyledDrawerOverlay = exports.StyledDrawerOverlay = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledDrawerOverlay",
  class: "sow2wj7",
  vars: {
    "sow2wj7-1": [props => props.height]
  }
});